module.exports = __webpack_public_path__ + "static/HyperionLanding-15b18a113e05b7d06bc6e95df7640e0f.png";